
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CoinsList from "./CoinsList";
import EmptyTabContent from "./EmptyTabContent";
import { UserCoin } from "@/types/profile";

interface ProfileTabsProps {
  isLoading: boolean;
  coins: UserCoin[];
  heldCoins: UserCoin[];
}

const ProfileTabs = ({ isLoading, coins, heldCoins }: ProfileTabsProps) => {
  return (
    <Tabs defaultValue="coins-created" className="w-full">
      <TabsList className="bg-card/50 text-muted-foreground">
        <TabsTrigger value="coins-created">coins created</TabsTrigger>
        <TabsTrigger value="coins-held">coins held</TabsTrigger>
        <TabsTrigger value="followers">followers</TabsTrigger>
        <TabsTrigger value="following">following</TabsTrigger>
      </TabsList>
      <TabsContent value="coins-created" className="mt-6">
        <CoinsList isLoading={isLoading} coins={coins} />
      </TabsContent>
      <TabsContent value="coins-held" className="mt-6">
        <CoinsList isLoading={isLoading} coins={heldCoins} emptyMessage="No coins held" />
      </TabsContent>
      <TabsContent value="followers" className="mt-6">
        <EmptyTabContent message="No followers yet" />
      </TabsContent>
      <TabsContent value="following" className="mt-6">
        <EmptyTabContent message="Not following anyone" />
      </TabsContent>
    </Tabs>
  );
};

export default ProfileTabs;
